import React from "react";
import { Link } from 'react-router-dom';
import User from 'components/users';


const GraphicStandPackedUserField = ({ graphicStand }) => {

    return (
        <div className='flex-field-box'>
            <span className='col'>
                { graphicStand?.relPackedUser ?
                    <Link to={ `${ User.Const.basePath }/${ graphicStand?.relPackedUser?.id }` }> { `${ graphicStand?.relPackedUser?.name } ${ graphicStand?.relPackedUser?.surname }` }</Link>
                    :
                    <strong>&mdash;</strong>
                }
            </span>
        </div>
    )
}


export default GraphicStandPackedUserField;